import { styled } from '@linaria/react'
import { COLOR } from 'vars/color'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'

export const ProfileTypeMenuButtonSC = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(${FIXED_INDENTS.INDENT_20});
  padding: var(${FIXED_INDENTS.INDENT_20}) var(${FIXED_INDENTS.INDENT_30});
  width: 100%;
  border-radius: var(${FIXED_INDENTS.INDENT_10});

  ${MEDIA.NO_TOUCH} {
    &:hover {
      background: var(${COLOR.SURFACE_DARK_4});
      cursor: pointer;
    }
  }

  ${MEDIA.MIN_600} {
    padding: var(${FIXED_INDENTS.INDENT_30}) var(${FIXED_INDENTS.INDENT_40});
  }
`

export const ProfileTypeMenuButtonTextSC = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
`
